import { useState, useEffect } from "react";
import { FaTimes, FaLinkedin } from "react-icons/fa";
import { getAllTeamMembers } from "../../Api";

const OurFounders = ({ language }) => {

  const [founders, setFounders] = useState([]);
  const [selectedFounder, setSelectedFounder] = useState(null);

  const langKey = language === "CN" ? "zh" : "en";

  useEffect(() => {

    const fetchData = async () => {

      try {

        const res = await getAllTeamMembers();

        if (res.data.success) {

          const allMembers = res.data.data;

          const founderOnly = allMembers.filter((item) =>
            item.category?.name?.en?.toLowerCase().includes("founder")
          );

          setFounders(founderOnly);
        }

      } catch (error) {
        console.log(error);
      }

    };

    fetchData();

  }, []);


  const IMAGE_BASE =
    process.env.REACT_APP_API_URL?.replace("/api", "") || "";


  return (

    <section className="bg-[#f7f7f7] py-10">

      <div className="max-w-[1320px] mx-auto px-6">


        {/* Heading */}
        <div className="text-center mb-10">
          <h2 className="text-[34px] font-medium text-[#154059]">
            {language === "CN" ? "我们的创始人" : "Our Founders"}
          </h2>
        </div>



        {/* Cards */}
        <div className="grid md:grid-cols-2 gap-8">


          {founders.map((founder) => {

            const description =
              founder.description?.[langKey] || "";

            const paragraphs =
              description.split(/(?<=\.)\s+/);


            return (

              <div
                key={founder._id}
                onClick={() => setSelectedFounder(founder)}
                className="cursor-pointer bg-white p-6 shadow-sm hover:shadow-lg transition-all duration-300"
              >


                <div className="flex flex-col sm:flex-row gap-6">


                  {/* Image */}
                  <img
                    src={`${IMAGE_BASE}/${founder.image.replace(/\\/g, "/")}`}
                    alt=""
                    className="w-full sm:w-[180px] h-[260px] object-cover object-top"
                  />


                  <div className="text-center sm:text-left">


                    {/* CATEGORY TOP */}
                    <div className="bg-[#f1f1f1] inline-block px-3 py-1 text-xs font-medium text-black mb-2 uppercase">
                      {founder.category?.name?.[langKey]?.replace("Founder-", "")}
                    </div>


                    {/* POSITION */}
                    <p className="text-[#C09F7C] text-sm uppercase mb-1">
                      {founder.position?.[langKey]}
                    </p>


                    {/* NAME */}
                    <h3 className="text-2xl font-medium text-[#154059] mb-2">
                      {founder.name?.[langKey]}
                    </h3>


                    {/* TEXT */}
                    <div className="text-gray-700 text-sm space-y-2 text-justify">
                      {paragraphs.slice(0, 2).map((para, i) => (
                        <p key={i}>{para}</p>
                      ))}
                    </div>


                    {/* LINKEDIN */}
                    {founder.socialLinks?.linkedin && (

                      <a
                        href={founder.socialLinks.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={(e) => e.stopPropagation()}
                        className="w-8 h-8 mt-3 flex items-center justify-center rounded-full bg-[#154059] text-white"
                      >
                        <FaLinkedin size={14} />
                      </a>

                    )}


                  </div>

                </div>

              </div>

            );

          })}

        </div>

      </div>



      {/* MODAL */}
      {selectedFounder && (

        <div className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm overflow-y-auto">

          <div className="relative bg-white w-full md:max-w-3xl mx-auto mt-6 md:mt-20 p-6 md:p-10 shadow-xl">

            <button
              onClick={() => setSelectedFounder(null)}
              className="absolute top-4 right-4 text-gray-500 hover:text-black"
            >
              <FaTimes size={18} />
            </button>


            <div className="flex flex-col md:flex-row gap-8">


              <div className="w-full md:w-[30%]">

                <img
                  src={`${IMAGE_BASE}/${selectedFounder.image.replace(/\\/g, "/")}`}
                  className="w-full h-[300px] md:h-[380px] object-cover object-top"
                />

              </div>


              <div className="w-full md:w-[70%]">


                <div className="bg-[#f1f1f1] inline-block px-3 py-1 text-xs mb-2 uppercase">
                  {selectedFounder.category?.name?.[langKey]?.replace("Founder-", "")}
                </div>


                <p className="text-[#C09F7C] uppercase mb-1">
                  {selectedFounder.position?.[langKey]}
                </p>


                <h3 className="text-2xl mb-3">
                  {selectedFounder.name?.[langKey]}
                </h3>


                <div className="space-y-3">

                  {selectedFounder.description?.[langKey]
                    ?.split(/(?<=\.)\s+/)
                    .map((para, i) => (
                      <p key={i}>{para}</p>
                    ))}

                </div>

              </div>

            </div>

          </div>

        </div>

      )}

    </section>
  );
};

export default OurFounders;